// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'team-member-settings',
        component: () =>
            import('@/pages/[organisation]/hr/team-member-settings/team-member-settings/[id].vue'),
        name: 'human-resource.team-member-settings.view-team-member-settings',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.team-member-setting.view-team-member-settings',
        },
    },

    {
        path: 'team-member-settings/edit',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-settings" */ '@/pages/[organisation]/hr/team-member-settings/team-member-settings/[id]/edit.vue'),
        name: 'human-resource.team-member-settings.update-team-member-settings',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.team-member-setting.update-team-member-settings',
        },
    },
];
